import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Lead } from '../../model/leads.model';
import { useDispatch, useSelector } from 'react-redux';
import { Enum } from '../../model/enum.model';
import { getAllLeads2 } from '../../api/leads.api';
import { setAllLeads } from '../../Redux/Leads/leadsAction';
import { getAllEnumFromServer } from '../../api/enum.api';
import { setAllStatusLeads } from '../../Redux/enum/statusLeadAction';
import "./graph.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const BarChart = () => {
    const [leads, setLeads] = useState<Lead[]>([]);
    console.log(leads,18);
    
    const [leadsStatus, setLeadsStatus] = useState<Enum[]>([]);
    const [leadStatusCount, setLeadStatusCount] = useState({
        "נסגר": 0,
        "הועברו לפרויקט": 0,
    });

    const [selectedDate, setSelectedDate] = useState<Date | null>(null); // State for selected date

    const total = leadStatusCount["נסגר"] + leadStatusCount["הועברו לפרויקט"];

    const closeLead = total ? ((leadStatusCount["נסגר"] / total) * 100).toFixed(2) : '0';

    const passLead = total ? ((leadStatusCount["הועברו לפרויקט"] / total) * 100).toFixed(2) : '0';

    const dispatch = useDispatch();
    const leadsState = useSelector((state: { leads: { allLeads: Lead[] } }) => state.leads);

    const leadStatus = useSelector((state: { statusLead: { allStatusLead: Enum[] } }) => state.statusLead);


    useEffect(() => {
        const fetchData = async () => {
            try {
                let data;
                if (leadsState.allLeads?.length) {
                    data = leadsState.allLeads;
                    console.log(data);
                    
                } else {
                    const resAllLeads = await getAllLeads2();
                    data = resAllLeads.data;
                    dispatch(setAllLeads(data));
                }
                setLeads(data);

                let statusData;
                if (leadStatus.allStatusLead?.length) {
                    statusData = leadStatus.allStatusLead;
                } else {
                    const resAllStatusLeads = await getAllEnumFromServer(5);
                    statusData = resAllStatusLeads.data;
                    dispatch(setAllStatusLeads(statusData));
                }
                setLeadsStatus(statusData);
            } catch (error) {
                console.error('Error fetching leads:', error);
            }
        };

        fetchData();
    }, [dispatch, leadsState.allLeads, leadStatus.allStatusLead]);

    useEffect(() => {
        if (leads?.length > 0) {
            statusCount();
        }
    }, [leads, selectedDate]);

    const statusCount = () => {
        const newLeadStatusCount = { "נסגר": 0, "הועברו לפרויקט": 0 };
        leads.filter((lead) => {
            if (!selectedDate)
                return true;
            // return new Date(lead.createdDate) >= selectedDate;
            return (
                lead.lastContacted &&
                new Date(lead.lastContacted).setHours(0, 0, 0, 0) <= selectedDate.setHours(0, 0, 0, 0)
            );


        }).forEach((lead) => {
            switch (lead.status) {
                case 'נסגר':
                    newLeadStatusCount['נסגר'] += 1;
                    break;
                case "הועברו לפרויקט":
                    newLeadStatusCount["הועברו לפרויקט"] += 1;
                    break;
                default:
                    console.warn(`Unknown status: ${lead.status}`);
            }
        });
        setLeadStatusCount(newLeadStatusCount);
    };
    
    // const statusCount = () => {
    //     const newLeadStatusCount = { "נסגר": 0, "הועברו לפרויקט": 0 };

    //     const selectedTime = selectedDate ? selectedDate.setHours(0, 0, 0, 0) : null;

    //     leads.filter((lead) => {
    //         if (!selectedTime) return true;

    //         const leadDate = lead.lastContacted ? new Date(lead.lastContacted).setHours(0, 0, 0, 0) : null;

    //         return leadDate && leadDate <= selectedTime;
    //     }).forEach((lead) => {
    //         switch (lead.status) {
    //             case 'נסגר':
    //                 newLeadStatusCount['נסגר'] += 1;
    //                 break;
    //             case "הועברו לפרויקט":
    //                 newLeadStatusCount["הועברו לפרויקט"] += 1;
    //                 break;
    //         }
    //     });

    //     setLeadStatusCount(newLeadStatusCount);
    // };


    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const dateValue = event.target.value;
        if (dateValue) {
            const date = new Date(dateValue);
            date.setHours(0, 0, 0, 0); // Set time to midnight for accurate date comparison
            setSelectedDate(date);
        } else {
            setSelectedDate(null);
        }
    };
    // setSelectedDate(event.target.value ? new Date(event.target.value) : null);
    // };

    const data = {
        labels: ['נסגרו', 'הועברו לפרויקט'],
        datasets: [
            {
                label: 'סטטוס לידים',
                data: [closeLead, passLead],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        const value = context.raw as number;
                        return value + '%';
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    callback: function (this: Scale, value: string | number) {
                        return value + '%';
                    }
                }
            }
        }
    };

    return (
        <div className='bar'>
            <Bar data={data} options={options} />
            <div id='dateFilter' className='hidden'>
                <input
                    type='date'
                    onChange={handleDateChange}
                />
                סנן
            </div>
        </div>
    );
};

export default BarChart;
